import React from 'react';
import './ContentSuggestions.css';

const allTips = [
  { section: 'summary', title: 'Professional Summary', tips: [
    'Keep it 2-4 sentences: who you are, what you do, what you want.',
    'Mention your years of experience and key areas of expertise.',
    'Include your most impressive quantifiable achievement.',
    'Tailor this section to each job application.',
    'Use active voice and avoid first-person pronouns ("I", "me", "my").'
  ]},
  { section: 'experience', title: 'Experience', tips: [
    'Start each bullet with a strong action verb (Developed, Led, Implemented).',
    'Quantify achievements with numbers: "Increased sales by 30%".',
    'Use the STAR format: Situation, Task, Action, Result.',
    'Focus on achievements, not just responsibilities.',
    'Keep bullets to 1-2 lines each; 3-6 bullets per role.'
  ]},
  { section: 'skills', title: 'Skills', tips: [
    'List 8-15 relevant skills for your target role.',
    'Include both hard skills (technical) and soft skills.',
    'Match skills to keywords in the job description.',
    'Order skills by relevance to the position.',
    'Remove outdated or irrelevant skills.'
  ]},
  { section: 'education', title: 'Education', tips: [
    'List degree, institution, and graduation date.',
    'Include GPA if 3.5+ or notable academic honors.',
    'Add relevant coursework for entry-level positions.',
    'Include study abroad programs if applicable.',
    'Omit high school if you have a college degree.'
  ]},
  { section: 'projects', title: 'Projects', tips: [
    'Describe the problem, your solution, and the impact.',
    'List the technologies and tools you used.',
    'Include links to live demos or GitHub repos.',
    'Highlight your specific contribution to team projects.',
    'Show measurable outcomes or user adoption metrics.'
  ]}
];

const ContentSuggestions = ({ data, onApply }) => {
  const hasData = Object.values(data).some(v => Array.isArray(v) ? v.length > 0 : v);

  return (
    <div className="content-suggestions">
      <div className="suggestions-header">
        <span className="suggestions-icon">💡</span>
        <span className="suggestions-title">Writing Tips</span>
      </div>

      <div className="suggestions-body">
        {!hasData && (
          <div className="suggestion-empty">
            Start filling in your resume data to get personalized tips.
          </div>
        )}

        {allTips.map(group => (
          <div key={group.section} className="tip-group">
            <div className="tip-group-title">{group.title}</div>
            {group.tips.map((tip, i) => (
              <div key={i} className="tip-item">
                <span className="tip-bullet">•</span>
                <span className="tip-text">{tip}</span>
              </div>
            ))}
          </div>
        ))}
      </div>

      <div className="suggestions-footer">
        <span className="footer-hint">Apply these tips to make your resume stronger</span>
      </div>
    </div>
  );
};

export default ContentSuggestions;
